import { Box, Typography } from '@mui/material'
import _ from 'lodash'
import { useCallback, useEffect, useState } from 'react'
import { numberFormat, numberToCurrencyFormat } from 'utils/app.utils'

/** TRANSLATION */
import { useTranslation } from 'react-i18next'

import TableCustom from 'component/Table/TableCustom'
import TableRowCommon from 'component/Table/TableRowCommon'

/** STYLE */
import * as UseStyled from 'features/report/useStyled'

import { SORT_TYPE } from 'constants/common'
import { dateToView, timeToView } from 'utils/date.utils'
import { UseSnCode } from 'utils/useSnCode'

export interface AdvanceComponent {
  page: number
  pageLimit: number
  rowCount: number
  data: any
  summary: any
  dataExport: any
  handleChangeRowsPerPage: (val: any) => void
  handleChangePage: (val: any) => void
  onRequestSort: (sortBy: string, sortType: string) => void
  setSortType: (val: SORT_TYPE) => void
  setSortBy: (val: string) => void
  sortType: string
  sortBy: string
}

interface AdvanceIncreaseIF {
  branchName: string
  createdAt: string
  advanceNumber: string
  statusOrder: string
  paymentChannel: string
  amountTotal: number
  createdBy: string
  remark: string
  cancelRemark: string
  cancelBy: string
  branchCnNumber: string
  cnNumber: string
  snCode: string
  patientFullname: string
}
interface AdvanceIncreaseSummaryIF {
  paymentChannelId: number
  amountTotal: number
  amountCancel: number
}
export default function AdvanceIncreaseList(props: AdvanceComponent) {
  const { t } = useTranslation()

  const [snType, setSnType] = useState(false)

  const handleSnCode = useCallback(() => {
    const fetchData = async () => {
      const sn = await UseSnCode()
      setSnType(sn)
    }

    fetchData()
  }, [snType])

  useEffect(() => {
    handleSnCode()
  }, [])

  const onRequestSort = (sortByVal: string, sortTypeVal: SORT_TYPE) => {
    props.setSortType(sortTypeVal)
    props.setSortBy(sortByVal)
    props.handleChangePage(1)
  }

  const headCells = [
    { id: '1', disablePadding: false, labelKey: 'REPORT.TABLE.DF.#NO', align: 'center', class: 'text-nowrap', width: '30px', style: { width: '30px' } },
    { id: '3', disablePadding: false, labelKey: 'REPORT.TABLE.DECREASE.BRANCH', align: 'center', class: 'text-nowrap', width: '150px', style: { width: '80px' } },
    { id: '4', disablePadding: false, labelKey: 'REPORT.TABLE.INCREASE.DATE_INCREASE', align: 'center', class: 'text-nowrap', width: '150px', style: { width: '60px' } },
    { id: '5', disablePadding: false, labelKey: 'REPORT.TABLE.DECREASE.BILL', align: 'center', class: 'text-nowrap', width: '150px', style: { width: '50px' } },
    { id: '6', disablePadding: false, labelKey: 'REPORT.TABLE.DECREASE.STATUS', align: 'center', class: 'text-nowrap', width: '250px', style: { width: '40px' } },
    { id: '7', disablePadding: false, labelKey: 'REPORT.TABLE.DECREASE.PATIENT_CN_NUMBER', align: 'center', class: 'text-nowrap', width: '350px' },
    { id: '7', disablePadding: false, labelKey: 'REPORT.TABLE.DECREASE.BRANCH_CN_NUMBER', align: 'center', class: 'text-nowrap', width: '350px', style: { width: '60px' } },
    { id: '7', disablePadding: false, labelKey: 'REPORT.TABLE.DECREASE.PATIENT_SN_CODE', align: 'center', class: 'text-nowrap', width: '350px', style: { width: '50px' } },
    { id: '7', disablePadding: false, labelKey: 'REPORT.TABLE.DECREASE.PATIENT_NAME', align: 'left', class: 'text-nowrap', width: '350px', style: { width: '50px' } },
    { id: '7', disablePadding: false, labelKey: 'REPORT.TABLE.INCREASE.CHANNEL_INCREASE', align: 'center', class: 'text-nowrap', width: '350px', style: { width: '60px' } },
    { id: '7', disablePadding: false, labelKey: 'REPORT.TABLE.INCREASE.TOTAL_INCREASE', align: 'right', class: 'text-nowrap', width: '350px', style: { width: '40px' } },
    { id: '7', disablePadding: false, labelKey: 'REPORT.TABLE.INCREASE.UPDATED_BY', align: 'center', class: 'text-nowrap', width: '350px', style: { width: '60px' } },
    { id: '7', disablePadding: false, labelKey: 'REPORT.TABLE.INCREASE.DETAIL', align: 'left', class: 'text-nowrap', width: '350px', style: { width: '40px' } },
    { id: '7', disablePadding: false, labelKey: 'REPORT.TABLE.INCREASE.REMARK_CANCEL', align: 'left', class: 'text-nowrap', width: '350px', style: { width: '60px' } },
    { id: '7', disablePadding: false, labelKey: 'REPORT.TABLE.INCREASE.CANCELER', align: 'center', class: 'text-nowrap', width: '350px', style: { width: '50px' } }
  ]
  const headTotalCells = [
    { id: '1', disablePadding: false, labelKey: 'REPORT.TABLE.INCREASE.CAP_PAY', align: 'left', class: 'text-nowrap', width: '30px' },
    { id: '3', disablePadding: false, labelKey: 'REPORT.TABLE.INCREASE.SUM_INCREASE', align: 'center', class: 'text-nowrap', width: '150px' },
    { id: '4', disablePadding: false, labelKey: 'REPORT.TABLE.INCREASE.SUM_CANCEL', align: 'center', class: 'text-nowrap', width: '150px' }
  ]

  if (!snType) {
    headCells.splice(7, 1)
  }
  const renderData = (data: any, no: number, render: 'data' | 'sum') => {
    if (render === 'data') {
      const advance: AdvanceIncreaseIF = data
      const num = props.page * props.pageLimit - props.pageLimit + no + 1
      const objRenderData = {
        key: num.toString(),
        id: no.toString(),
        obj: data,
        columns: [
          { option: 'TEXT', align: 'center', style: { fontSize: 16 }, label: num, class: 'text-nowrap' },
          { option: 'TEXT', align: 'center', style: { fontSize: 16 }, label: advance.branchName, class: 'text-nowrap' },
          {
            option: 'TEXT',
            align: 'center',
            style: { fontSize: 16 },
            label: (
              <>
                {dateToView(advance.createdAt)} <br /> {timeToView(advance.createdAt)} น.
              </>
            ),
            class: 'text-nowrap'
          },
          { option: 'TEXT', align: 'center', style: { fontSize: 16 }, label: advance.advanceNumber, class: 'text-nowrap' },
          { option: 'TEXT', align: 'center', style: { fontSize: 16 }, label: t(`REPORT.BILL_STATUS.${advance.statusOrder}`), class: 'text-nowrap' },
          { option: 'TEXT', align: 'center', style: { fontSize: 16 }, label: advance.cnNumber, class: 'text-nowrap' },
          { option: 'TEXT', align: 'center', style: { fontSize: 16 }, label: advance.branchCnNumber, class: 'text-nowrap' },
          { option: 'TEXT', align: 'center', style: { fontSize: 16 }, label: advance.snCode || '-', class: 'text-nowrap' },
          { option: 'TEXT', align: 'left', style: { fontSize: 16 }, label: advance.patientFullname, class: 'text-nowrap' },
          { option: 'TEXT', align: 'center', style: { fontSize: 16 }, label: advance.paymentChannel, class: 'text-nowrap' },
          { option: 'TEXT', align: 'right', style: { fontSize: 16 }, label: numberFormat(advance.amountTotal, 2), class: 'text-nowrap' },
          { option: 'TEXT', align: 'center', style: { fontSize: 16 }, label: advance.createdBy, class: 'text-nowrap' },
          { option: 'TEXT', align: 'left', style: { fontSize: 16 }, label: <div dangerouslySetInnerHTML={{ __html: advance.remark || '' }} />, class: 'text-nowrap' },
          { option: 'TEXT', align: 'left', style: { fontSize: 16 }, label: advance.cancelRemark || '-', class: 'text-nowrap' },
          { option: 'TEXT', align: 'center', style: { fontSize: 16 }, label: advance.cancelBy || '-', class: 'text-nowrap' }
        ]
      }
      if (!snType) {
        objRenderData.columns.splice(7, 1)
      }
      return <TableRowCommon {...objRenderData} />
    } else {
      const objRenderData = {
        key: no.toString(),
        id: no.toString(),
        obj: data,
        columns: [
          { option: 'MERGE', align: 'center', colSpan: !snType ? 8 : 9 },
          {
            option: 'TEXT',
            align: 'right',
            style: { fontSize: 16 },
            label: <Typography sx={{ fontWeight: 500, fontSize: 16 }}>{t('REPORT.TITLE.SUM')}</Typography>,
            class: 'text-nowrap'
          },
          { option: 'TEXT', align: 'right', style: { fontSize: 16 }, label: numberFormat(_.sumBy(data, 'amountTotal') || 0), class: 'text-nowrap' },
          { option: 'MERGE', align: 'center', colSpan: 4 },

        ],
        classes: 'row-summary'
      }
      return <TableRowCommon {...objRenderData} />
    }
  }
  const renderSummary = () => {
    const summary = props.summary
    const sumChannel1 = _.find(props.summary, { paymentChannelId: 1 })
    const sumChannel2 = _.find(props.summary, { paymentChannelId: 2 })
    const sumChannel3 = _.find(props.summary, { paymentChannelId: 3 })
    const sumChannel4 = _.find(props.summary, { paymentChannelId: 4 })
    const sumChanel = {
      text: "TOTAL",
      amountTotal: (sumChannel1?.amountTotal || 0) + (sumChannel2?.amountTotal || 0) + (sumChannel3?.amountTotal || 0) + (sumChannel4?.amountTotal || 0),
      amountCancel: (sumChannel1?.amountCancel || 0) + (sumChannel2?.amountCancel || 0) + (sumChannel3?.amountCancel || 0) + (sumChannel4?.amountCancel || 0)
    }

    const objRenderData1 = {
      key: 'chanel-1',
      id: 'chanel-1',
      obj: sumChannel1,
      columns: [
        { option: 'TEXT', align: 'left', style: { fontSize: 16 }, label: t(`REPORT.PAYMENT_CHANNEL.1`), class: 'text-nowrap cap-pay' },
        { option: 'TEXT', align: 'right', style: { fontSize: 16 }, label: numberToCurrencyFormat(sumChannel1?.amountTotal || 0), class: 'text-nowrap' },
        { option: 'TEXT', align: 'right', style: { fontSize: 16 }, label: numberToCurrencyFormat(sumChannel1?.amountCancel || 0), class: 'text-nowrap' }
      ]
    }
    const objRenderData2 = {
      key: 'chanel-2',
      id: 'chanel-2',
      obj: sumChannel2,
      columns: [
        { option: 'TEXT', align: 'left', style: { fontSize: 16 }, label: t(`REPORT.PAYMENT_CHANNEL.2`), class: 'text-nowrap cap-pay' },
        { option: 'TEXT', align: 'right', style: { fontSize: 16 }, label: numberToCurrencyFormat(sumChannel2?.amountTotal || 0), class: 'text-nowrap' },
        { option: 'TEXT', align: 'right', style: { fontSize: 16 }, label: numberToCurrencyFormat(sumChannel2?.amountCancel || 0), class: 'text-nowrap' }
      ]
    }
    const objRenderData3 = {
      key: 'chanel-3',
      id: 'chanel-3',
      obj: sumChannel3,
      columns: [
        { option: 'TEXT', align: 'left', style: { fontSize: 16 }, label: t(`REPORT.PAYMENT_CHANNEL.3`), class: 'text-nowrap cap-pay' },
        { option: 'TEXT', align: 'right', style: { fontSize: 16 }, label: numberToCurrencyFormat(sumChannel3?.amountTotal || 0), class: 'text-nowrap' },
        { option: 'TEXT', align: 'right', style: { fontSize: 16 }, label: numberToCurrencyFormat(sumChannel3?.amountCancel || 0), class: 'text-nowrap' }
      ]
    }
    const objRenderData4 = {
      key: 'chanel-4',
      id: 'chanel-4',
      obj: sumChannel4,
      columns: [
        { option: 'TEXT', align: 'left', style: { fontSize: 16 }, label: t(`REPORT.PAYMENT_CHANNEL.4`), class: 'text-nowrap cap-pay' },
        { option: 'TEXT', align: 'right', style: { fontSize: 16 }, label: numberToCurrencyFormat(sumChannel4?.amountTotal || 0), class: 'text-nowrap' },
        { option: 'TEXT', align: 'right', style: { fontSize: 16 }, label: numberToCurrencyFormat(sumChannel4?.amountCancel || 0), class: 'text-nowrap' }
      ]
    }

    const sumObjRenderData = {
      key: 'chanel-sum',
      id: 'chanel-sum',
      obj: sumChanel,
      columns: [
        { option: 'TEXT', align: 'left', style: { fontSize: 16 }, label: t(`REPORT.TABLE.INCREASE.SUM_TOTAL`), class: 'text-nowrap cap-pay' },
        { option: 'TEXT', align: 'right', style: { fontSize: 16 }, label: numberToCurrencyFormat(sumChanel?.amountTotal || 0), class: 'text-nowrap' },
        { option: 'TEXT', align: 'right', style: { fontSize: 16 }, label: numberToCurrencyFormat(sumChanel?.amountCancel || 0), class: 'text-nowrap' }
      ],
      classes: 'row-summary'
    }

    return [
      <>{<TableRowCommon {...objRenderData1} />}</>,
      <>{<TableRowCommon {...objRenderData2} />}</>,
      <>{<TableRowCommon {...objRenderData3} />}</>,
      <>{<TableRowCommon {...objRenderData4} />}</>,
      <>{<TableRowCommon {...sumObjRenderData} />}</>,
    ]

    return <></>

  }

  return (
    <>
      <Box>
        <UseStyled.ResponsiveReportTable>
          <TableCustom
            rowHeadCell={2}
            // tableMinWidth={992}
            page={props.page}
            pageLimit={props.pageLimit}
            sortType={props.sortType}
            sortBy={props.sortBy}
            rowCount={props.rowCount}
            onSort={onRequestSort}
            setPageLimit={props.handleChangeRowsPerPage}
            setPage={props.handleChangePage}
            headCells={headCells}
            rowsData={[
              _.map(props.data, (d: any, index: number) => {
                return renderData(d, index, 'data')
              }),
              renderData(props.dataExport, 0, 'sum')
            ]}
            customScroll
          />
        </UseStyled.ResponsiveReportTable>
      </Box>
      <Box className="mt-3" sx={{ maxWidth: '480px' }}>
        <UseStyled.ResponsiveReportTable className="mt-2">
          <TableCustom
            hidePagination
            page={props.page}
            pageLimit={props.pageLimit}
            sortType={props.sortType}
            sortBy={props.sortBy}
            rowCount={props.rowCount}
            onSort={props.onRequestSort}
            setPageLimit={props.handleChangeRowsPerPage}
            setPage={props.handleChangePage}
            headCells={headTotalCells}
            rowsData={[renderSummary()]}
            tableMinWidth={480}
            customScroll
          />
        </UseStyled.ResponsiveReportTable>
      </Box>
    </>
  )
}
